<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer006">
<p class="basic-paragraph"><span class="charoverride3"><br class="calibre1"/></span></p>
<h1 class="basic-paragraph"><span class="charoverride3">Dedication</span></h1>
<p class="basic-paragraph"><span class="charoverride2"><br class="calibre2"/></span></p>
<p class="basic-paragraph"><span class="charoverride2">For Elise and Don, Irene and Tom</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?bad6342c